jQuery(document).ready(function(){
    var networkListCount = jQuery( ".networks li" ).length;
    var additionalElements = jQuery(".networks li:nth-child(n+5");
    var showNetworksButton = jQuery(".network-button");

    additionalElements.css("display", "none");

    if(networkListCount > 3){
        jQuery('.network-button').css('display', 'block');
        jQuery(showNetworksButton).on( "click", function() {
            additionalElements.css("display", additionalElements.css("display") === 'none' ? '' : 'none');
            jQuery(this).toggleClass('expanded');
            var expanded = jQuery(this).attr('aria-expanded');
            if(expanded == 'true'){
                jQuery(this).attr('aria-expanded', false);
                jQuery(this).attr('aria-label', 'Näytä kaikki');
            }else{
                jQuery(this).attr('aria-expanded', true);
                jQuery(this).attr('aria-label', 'Näytä vähemmän');
            }
            return false;
        });
    }
});